module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.bae4a87c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome-webfont.svg
// module id = 2531
// module chunks = 7